/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ITenantIntegrationChannel } from 'app/shared/model/tenant-integration-channel.model';
import { ITenantIntegrationTemplate } from 'app/shared/model/tenant-integration-template.model';
import { OperationType } from 'app/shared/model/enumerations/operation-type.model';

export interface ICommunicationLog {
  id?: string;
  recepient?: string | null;
  status?: string | null;
  noOfRetries?: number | null;
  requestURI?: string | null;
  requestMsg?: string | null;
  requestStartTime?: number | null;
  responseStartTime?: number | null;
  responseCode?: number | null;
  responseMsg?: string | null;
  active?: boolean | null;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  eventName?: string | null;
  operationType?: keyof typeof OperationType | null;
  tenantId?: string | null;
  channel?: ITenantIntegrationChannel | null;
  template?: ITenantIntegrationTemplate | null;
}

export const defaultValue: Readonly<ICommunicationLog> = {
  active: false,
};
